// extracted by mini-css-extract-plugin
module.exports = {"container_list":"GlobalList_container_list__2aGJq","segment_padding":"GlobalList_segment_padding__3Jx0e","unauthorised_page":"GlobalList_unauthorised_page__3_uU_"};